<div class="container">
     <div class="maintenance-info-container">
          <div class="maintenance-header">We'll be back soon</div>
          <div class="maintenance-info">
               {{ maintenanceMsg }}
          </div>
          <div class="maintenance-contact">
               Need assistance?  <span><a href="mailto:support@rubii.io">Email us!</a></span>
          </div>
     </div>
</div>